// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".survio-src-components-InAppModal--modalContent .styledBody {\n  padding: 0 !important;\n}\n.survio-src-components-InAppModal--modalContent .styledBody .content {\n  height: 100%;\n}\n", "",{"version":3,"sources":["styles.less"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;AACd","file":"styles.less","sourcesContent":[".modalContent :global(.styledBody) {\n  padding: 0 !important;\n}\n.modalContent :global(.styledBody) :global(.content) {\n  height: 100%;\n}\n"]}]);
// Exports
exports.locals = {
	"modalContent": "survio-src-components-InAppModal--modalContent"
};
module.exports = exports;
